module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Assessments","noPurchases":"No purchases yet."},"es":{"title":"Evaluaciones","noPurchases":"Sin compras todavía."},"sw":{"title":"Tathmini","noPurchases":"Hakuna ununuzi bado."}}')
  delete Component.options._Ctor
}
